import { queryFirst, remove, addClass } from './domUtil';
import { getJSON } from './util';

const storeEventsContainer = queryFirst('.store-events-container');
const preferredStoresLabel = queryFirst('.page-title .preferred-store-label', storeEventsContainer);
const setPreferredStoreLinkEl = queryFirst('.set-preferred-store a', storeEventsContainer);

/**
 * Method to remove preferred store link
 */
function removePreferredStoreLink() {
    remove(setPreferredStoreLinkEl);
}

/**
 * Method to show preferred store label beside store name
 */
function showPreferredStoreLabel() {
    if (preferredStoresLabel) {
        addClass(preferredStoresLabel, 'show');
    }
}

/**
 * Method to initialize events
 */
function initilizeEvents() {
    if (setPreferredStoreLinkEl) {
        setPreferredStoreLinkEl.addEventListener('click', (event) => {
            const { actionUrl, storeId } = event.target.dataset;

            $.spinner().start();
            getJSON(actionUrl, 'POST', { storeID: storeId }, (response) => {
                if (response.message === 'success') {
                    removePreferredStoreLink();
                    showPreferredStoreLabel();
                }
                $.spinner().stop();
            }, () => {
                $.spinner().stop();
            });
        });
    }
}

document.addEventListener('DOMContentLoaded', () => {
    initilizeEvents();
});
